import cookieUtils from '@s-ui/js/lib/cookie'

import {COCHES_HOSTNAME, MOTOS_HOSTNAME} from '../config.js'
import {isClient, isCoches, isTestDomain} from '../utils.js'
import cochesConfig from './coches/index.js'
import motosConfig from './motos/index.js'

const userCookieKey = isCoches ? 'UserData' : 'MotosUserData'

const _getUserEmail = cookies => {
  if (typeof cookies !== 'string') return

  const {parse} = cookieUtils
  const {[userCookieKey]: userCookie} = parse(cookies)
  let userEmail

  try {
    userEmail = userCookie && JSON.parse(userCookie).email
  } catch (err) {
    console.error(err) // eslint-disable-line
  }

  return userEmail
}

let setInitialConfig = () => {
  if (!isClient || window.isMpiInitialized === true) return

  const siteConfig = !isTestDomain && (isCoches ? cochesConfig : motosConfig)
  const site = isCoches ? COCHES_HOSTNAME : MOTOS_HOSTNAME
  const sessionSavedSearchOwnerId = window.sessionStorage.getItem('savedSearchOwnerId')
  const location = new URLSearchParams(document.location.search)
  const savedSearchOwnerIdFromURL = location.get('savedSearchOwnerId')
  const hasSessionSavedSearchOwnerId = Boolean(sessionSavedSearchOwnerId) || Boolean(savedSearchOwnerIdFromURL)

  if (Boolean(savedSearchOwnerIdFromURL) && !sessionSavedSearchOwnerId) {
    window.sessionStorage.setItem('savedSearchOwnerId', savedSearchOwnerIdFromURL)
  }

  const savedSearchOwnerId = sessionSavedSearchOwnerId || savedSearchOwnerIdFromURL

  window.__SEGMENT_WRAPPER = {
    ADOBE_ORG_ID: '05FF6243578784B37F000101@AdobeOrg',
    TRACKING_SERVER: 'schibstedspain.d3.sc.omtrdc.net'
  }

  window.__mpi = window.__mpi || {}
  window.__mpi.segmentWrapper = {
    ...siteConfig,
    defaultProperties: {
      ...(hasSessionSavedSearchOwnerId && {savedSearchOwnerId}),
      site,
      vertical: 'motor'
    },
    importAdobeVisitorId: true,
    userEmail: _getUserEmail(window.document.cookie)
  }

  // Avoid to set the initial config more than once.
  window.isMpiInitialized = true // Avoid conflicts with segment-wrapper packages from different sites
  setInitialConfig = () => {}
}

setInitialConfig()
